import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionModel } from '../../models/permission.model';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';

import { ReportsService } from '../../services/reports.service';
import { 
  ISearchCustomer, 
  ISearchOrder, 
  ISearchColorMix,
  ISearchRoomAccounting,
  ISearchRoomProduce,
  ISearchProduct,
  ISearchColorList,
  ISearchColorType,
  ISearchListFormula,
  ISearchListColorExist,
  ISearchListEmployee
} from '../../interfaces/ISearchParam';

import {
  MatRadioChange,
  MatPaginator,
  MatDialogRef,
  MatDialog,
  MatSelectChange,
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatTableDataSource,
  MatSnackBar,
  MatSnackBarConfig,
  MatSort,
  MatDatepickerInputEvent,
  MatChipInputEvent,
  NativeDateAdapter,
  DateAdapter,
  MAT_DATE_FORMATS
} from '@angular/material';

import { WarningComponent } from '../../toast/warning/warning.component';
import { SuccessComponent } from '../../toast/success/success.component';
import { FailComponent } from '../../toast/fail/fail.component';

//Download PDF
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  providers: [AuthenticationService]
})
export class MenuComponent implements OnInit {
  auth: any = JSON.parse(sessionStorage.getItem("auth"));
  userId: string = this.auth.UserId;

  successConfig: MatSnackBarConfig = { panelClass: 'success-dialog', horizontalPosition: 'end', duration: 5000 };
  warningConfig: MatSnackBarConfig = { panelClass: 'warning-dialog', horizontalPosition: 'end', duration: 5000 };
  failConfig: MatSnackBarConfig = { panelClass: 'fail-dialog', horizontalPosition: 'end', duration: 5000 };

  @Input() moduleCode: string;
  permissions: Array<PermissionModel> = [];
  value: any;
  isAdmin: boolean;
  isCustomer: boolean;
  isSales: boolean;
  isProduct: boolean;
  isRoom: boolean;
  isHrm: boolean;
  isReports: boolean;

  userPermission: any = localStorage.getItem('UserPermission').split(',');
  leadPermission = 'lead';
  employeePermission = 'employee';
  employeeCreatePermission = 'employee/create';
  adminPermission = 'admin';
  customerPermission = 'customer';
  customerCreatePermission = 'customer/create';
  vendorPermission = 'vendor';
  vendorCreatePermission = 'vendor/create';

  listManagerPermission = 'listManager';
  paintManagerPermission = 'listManager/paint';
  colorManagerPermission = 'listManager/color';
  formulaPermission = 'listManager/formula';
  colorPaintExitPermission = 'listManager/colorPaintExit';

  orderPermission = 'order';
  roomProducePermission = 'order/room-produce';
  colorMixPermission = 'order/color-mix';
  roomAccountingPermission = 'order/room-accounting';
  orderListPermission = 'order/list';
  roomInternalPermission = 'order/room-internal';

  orderCreatePermission = 'order/create';
  payableCreatePermission = 'payable/create';
  bankPayableCreatePermission = 'bankpayable/create';
  receiptCreatePermission = 'receipt/create';
  bankReceiptPermission = 'bankreceipt';
  bankReceiptCreatePermission = 'bankreceipt/create';
  cashBookPermission = 'cashbook';
  bankBookPermission = 'bankbook';
  receiveCustomerPermission = 'receiveable-cus';
  receiveCustomerExcelPermission = 'receiveable-cus/excel';
  receiveVendorPermission = 'receiveable-ven';
  receiveVendorExcelPermission = 'receiveable-ven/excel';
  receiveCustomerViewPermission = 'view-receive-cus';
  receiveCustomerViewExcelPermission = 'view-receive-cus/excel';
  receiveVendorViewPermission = 'view-receive-ven';
  receiveVendorViewExcelPermission = 'view-receive-ven/excel';
  salesReportPermission = 'listManager/report';

  constructor(
    public snackBar: MatSnackBar,
    private authService: AuthenticationService,
    private translate: TranslateService,
    private router: Router,
    private commonService: CommonService,
    private reportsService: ReportsService,
  ) {
    this.translate.setDefaultLang('vi');
  }
  ngOnInit() {
    if (this.checkUserPermission(this.adminPermission)) {
      this.isAdmin = true;     
    } else if (this.checkUserPermission(this.employeeCreatePermission)) {
      this.isAdmin = false;      
    } else if (this.checkUserPermission(this.paintManagerPermission)) {
      this.isAdmin = false;
      //localStorage.setItem('menuIndex', 'sales');
    } else if (this.checkUserPermission(this.orderPermission)) {
      this.isAdmin = false;
      //localStorage.setItem('menuIndex', 'room');
    } 
    this.authService
      .getMenuByModuleCode(this.moduleCode)
      .subscribe(result => {
        this.permissions = result;
      }, error => {
      });
    const menuIndex = localStorage.getItem('menuIndex');
    if (menuIndex !== '' && menuIndex !== 'null' && menuIndex != null) {
      this.changeMenuTo(menuIndex);
    }
  }
  onHomeClick() {
    localStorage.removeItem('menuIndex');
    this.router.navigate(['/home']);
  }

  checkUserPermission(permission: string) {
    return (this.userPermission.indexOf(permission) !== -1);
  }

  changeMenuTo(module) {
    this.setModuleToFalse();
    switch (module) {
      case 'admin':
        this.isAdmin = true;
        break;
      case 'customer':
        this.isCustomer = true;
        break;
      case 'sales':
        this.isSales = true;
        break;
      case 'order':
        this.isRoom = true;
        break;
      case 'employee':
        this.isHrm = true;
        break;
      case 'reports':
        this.isReports = true;
        break;
      default:
        break;
    }
    localStorage.setItem('menuIndex', module);
  }
  setModuleToFalse() {
    this.isCustomer = false;
    this.isSales = false;
    this.isProduct = false;
    this.isRoom = false;
    this.isHrm = false;
    this.isAdmin = false;
    this.isReports = false;
  }

  goToLead() {
    this.router.navigate(['/lead/list']);
  }
  goToCreateLead() {
    this.router.navigate(['/lead/create-lead']);
  }
  goToDashboard() {
    this.router.navigate(['/lead/dashboard']);
  }

  goToDashboardCustomer(){
    this.router.navigate(['/customer/dashboard']);
  }

  goToQuoteCreate(){
    this.router.navigate(['/customer/quote-create']);
  }

  goToQuoteList(){
    this.router.navigate(['/customer/quote-list']);
  }

  goToCustomerDashboard() {
    this.router.navigate(['/customer/dashboard']);
  }

  goToVendor() {
    this.router.navigate(['/vendor/list']);
  }
  goToCreateVendor() {
    this.router.navigate(['/vendor/create']);
  }

  goToProductService() {
    let productSearch: ISearchProduct = JSON.parse(sessionStorage.getItem('productSearch'));
    productSearch.fromBack = false;

    sessionStorage.removeItem('productSearch');
    sessionStorage.setItem('productSearch', JSON.stringify(productSearch));

    this.router.navigate(['/product/list']);
  }
  goToSalesDashboard() {
    this.router.navigate(['/sales/dashboard']);
  }
  goToEmployeeTopRevenue(){
    this.router.navigate(['/sales/top-revenue']);
  }
  goToCreateProductService() {
    this.router.navigate(['/product/create']);
  }
  goToImportPaintService() {
    this.router.navigate(['product/import-paint']);
  }
  goToPaintFormulaService() {
    this.router.navigate(['product/paint-formula']);
  }
  goToColorPaintExit() {
    let listColorExistSearch: ISearchListColorExist = JSON.parse(sessionStorage.getItem('listColorExistSearch'));
    listColorExistSearch.fromBack = false;

    sessionStorage.removeItem('listColorExistSearch');
    sessionStorage.setItem('listColorExistSearch', JSON.stringify(listColorExistSearch));

    this.router.navigate(['formula/listColorExist']);
  }
  goToOrder() {
    let orderSearch: ISearchOrder = JSON.parse(sessionStorage.getItem('orderSearch'));
    orderSearch.fromBack = false;

    sessionStorage.removeItem('orderSearch');
    sessionStorage.setItem('orderSearch', JSON.stringify(orderSearch));

    this.router.navigate(['/order/list']);
  }
  goToCreateOrder() {
    this.router.navigate(['/order/create']);
  }
  goToCreateOrderInternal() {
    this.router.navigate(['/order/create-internal']);
  }
  goToPayable() {
    this.router.navigate(['/accounting/cash-payments-list']);
  }
  goToCreatePayable() {
    this.router.navigate(['/accounting/cash-payments-create']);
  }
  goToReceipt() {
    this.router.navigate(['/accounting/cash-receipts-list']);
  }
  goToCreateReceipt() {
    this.router.navigate(['/accounting/cash-receipts-create']);
  }
  goToReceivableVendor() {
    this.router.navigate(['/accounting/receivable-vendor-report']);
  }
  goToReceivableCustomer() {
    this.router.navigate(['/accounting/receivable-customer-report']);
  }
  goToEmployee() {
    let listEmployeeSearch: ISearchOrder = JSON.parse(sessionStorage.getItem('listEmployeeSearch'));
    listEmployeeSearch.fromBack = false;

    sessionStorage.removeItem('listEmployeeSearch');
    sessionStorage.setItem('listEmployeeSearch', JSON.stringify(listEmployeeSearch));
    
    this.router.navigate(['/employee/list']);
  }
  goToCreateEmployee() {
    this.router.navigate(['/employee/create']);
  }

  goToOrg() {
    this.router.navigate(['/admin/organization']);
  }
  goToMasterData() {
    this.router.navigate(['/admin/masterdata']);
  }
  goToPermission() {
    this.router.navigate(['/admin/permission']);
  }
  goToProductCategpry() {
    this.router.navigate(['/admin/list-product-category']);
  }
  goToConfig() {
    this.router.navigate(['/admin/company-config']);
  }
  goToConfigLevelCustomer() {
    this.router.navigate(['/admin/config-level-customer']);
  }
  goToCreateCustomer() {
    this.router.navigate(['/customer/create']);
  }
  goToCustomer() {
    let customerSearch: ISearchCustomer = JSON.parse(sessionStorage.getItem('customerSearch'));
    customerSearch.fromBack = false;

    sessionStorage.removeItem('customerSearch');
    sessionStorage.setItem('customerSearch', JSON.stringify(customerSearch));

    this.router.navigate(['/customer/list']);
  }
  goToBankPayable() {
    this.router.navigate(['/accounting/bank-payments-list']);
  }
  goToCreateBankPayable() {
    this.router.navigate(['/accounting/bank-payments-create']);
  }
  goToBankReceipt() {
    this.router.navigate(['/accounting/bank-receipts-list']);
  }
  goToCreateBankReceipt() {
    this.router.navigate(['/accounting/bank-receipts-create']);
  }
  goToBankPayments() {
    this.router.navigate(['/accounting/bank-payments-create']);
  }
  goToListBankPayments() {
    this.router.navigate(['/accounting/bank-payments-list']);
  }
  goToSalesReport() {
    this.router.navigate(['/accounting/sales-report']);
  }

  goToCashbook() {
    this.router.navigate(['/accounting/cash-book']);
  }

  goToBankbook() {
    this.router.navigate(['/accounting/bank-book']);
  }

  goToSalary(){
    this.router.navigate(['/employee/employee-salary/list']);
  }

  goToWorkflow(){
    this.router.navigate(['/admin/workflow/workflow-list']);
  }

  goToTeacherSalary(){
    this.router.navigate(['/employee/teacher-salary/list']);
  }

  goToAssistantSalary(){
    this.router.navigate(['/employee/assistant-salary/list']);
  }

  goToProcurementCreate(){
    this.router.navigate(['/procurement-request/create']);
  }

  goToProcurementList(){
    this.router.navigate(['/procurement-request/list']);
  }

  goToEmployeeRequest(){
    this.router.navigate(['/employee/request/list']);
  }

  goToProcurementPlan(){
    this.router.navigate(['/accounting/budget-list']);
  }
  goToListOrderVendor(){
    this.router.navigate(['/vendor/list-order']);
  }
  goToCreateOrderVendor(){
    this.router.navigate(['/vendor/create-order']);
  }
  goToEmpDashboard(){
    this.router.navigate(['/employee/dashboard']);
  }
  goToSaleDashboard(){
    this.router.navigate(['/sales/dashboard']);
  }
  goToColorMix(){
    let colorMixSearch: ISearchColorMix = JSON.parse(sessionStorage.getItem('colorMixSearch'));
    colorMixSearch.fromBack = false;

    sessionStorage.removeItem('colorMixSearch');
    sessionStorage.setItem('colorMixSearch', JSON.stringify(colorMixSearch));

    this.router.navigate(['/sales/color-mix']);
  }
  goToColorMixInternal() {
    this.router.navigate(['/sales/color-mix-internal']);
  }
  goToRoomAccounting(){
    let roomAccountingSearch: ISearchRoomAccounting = JSON.parse(sessionStorage.getItem('roomAccountingSearch'));
    roomAccountingSearch.fromBack = false;

    sessionStorage.removeItem('roomAccountingSearch');
    sessionStorage.setItem('roomAccountingSearch', JSON.stringify(roomAccountingSearch));
    
    this.router.navigate(['/sales/room-accounting']);
  }
  goToRoomProduce(){
    let roomProduceSearch: ISearchRoomProduce = JSON.parse(sessionStorage.getItem('roomProduceSearch'));
    roomProduceSearch.fromBack = false;

    sessionStorage.removeItem('roomProduceSearch');
    sessionStorage.setItem('roomProduceSearch', JSON.stringify(roomProduceSearch));

    this.router.navigate(['/sales/room-produce']);
  }
  goToRoomInternal() {
    let roomInternalSearch: ISearchRoomProduce = JSON.parse(sessionStorage.getItem('roomInternalSearch'));
    roomInternalSearch.fromBack = false;

    sessionStorage.removeItem('roomInternalSearch');
    sessionStorage.setItem('roomInternalSearch', JSON.stringify(roomInternalSearch));

    this.router.navigate(['/sales/room-internal']);
  }
  goToColorList(){
    let colorListSearch: ISearchColorList = JSON.parse(sessionStorage.getItem('colorListSearch'));
    colorListSearch.fromBack = false;

    sessionStorage.removeItem('colorListSearch');
    sessionStorage.setItem('colorListSearch', JSON.stringify(colorListSearch));

    this.router.navigate(['/sales/color-list']);
  }
  goToColorDensity(){
    this.router.navigate(['/sales/color-density']);
  }
  goToColorBox(){
    this.router.navigate(['/sales/list-color-box']);
  }
  goToColorType(){
    let colorTypeSearch: ISearchColorType = JSON.parse(sessionStorage.getItem('colorTypeSearch'));
    colorTypeSearch.fromBack = false;

    sessionStorage.removeItem('colorTypeSearch');
    sessionStorage.setItem('colorTypeSearch', JSON.stringify(colorTypeSearch));

    this.router.navigate(['/sales/color-type']);
  }
  goToColorAdd(){
    this.router.navigate(['/sales/color-add']);
  }

  /*Sao lưu dữ liệu*/
  goToExportData() {
    this.router.navigate(['/admin/exportData']);
  }

  goToClearData() {
    this.router.navigate(['/admin/clearData']);
  }
  /*End*/

  /*Quản lý công thức*/
  goToCreateFormula() {
    this.router.navigate(['/formula/create']);
  }

  goToListFormula() {
    let listFormulaSearch: ISearchListFormula = JSON.parse(sessionStorage.getItem('listFormulaSearch'));
    listFormulaSearch.fromBack = false;

    sessionStorage.removeItem('listFormulaSearch');
    sessionStorage.setItem('listFormulaSearch', JSON.stringify(listFormulaSearch));

    this.router.navigate(['/formula/list']);
  }

  goToCopyFormula() {
    this.router.navigate(['/formula/copy']);
  }
  /*End*/

  /*Báo cáo*/
  goToReportListRelease() {
    this.router.navigate(['reports/list-release']);
  }

  //Báo cáo danh sách màu tồn
  async exportListInventoryColor() {
    let result: any = await this.reportsService.getAllColorPaintExist(this.userId);
    if (result.statusCode == 200) {
      if (result.colorPaintExistList.length > 0) {
        let listData: Array<any> = result.colorPaintExistList;
        let documentDefinition = {
          pageSize: 'A4',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'DANH SÁCH MÀU TỒN', style: 'header', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    body: [
                      [
                        { text: 'Mã sơn', style: 'tableHeader', alignment: 'center' },
                        { text: 'Mã màu', style: 'tableHeader', alignment: 'center' },
                        { text: 'Khối lượng (kg)', style: 'tableHeader', alignment: 'center' },
                        { text: 'Ngày tháng', style: 'tableHeader', alignment: 'center' },
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: false,
                    paddingLeft: function (i, node) { return 10; },
                    paddingRight: function (i, node) { return 10; },
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; }
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            },
            sumRow: {
              fontSize: 12,
              bold: true
            }
          }
        };

        let sum: number = 0;
        listData.forEach(item => {
          sum += item.mass;
          let option = [];

          let current_product_code = {
            text: item.productCode,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_product_code);

          let current_color_code = {
            text: item.colorCode,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_color_code);

          let current_mass = {
            text: item.mass,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_mass);

          let current_created_date = {
            text: this.formatDate(item.createdDate),
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_created_date);

          documentDefinition.content[1].columns[1].table.body.push(option);
        });

        let sum_row = [];
        let current_title = {
          text: 'Tổng',
          alignment: 'center',
          style: 'sumRow'
        };
        sum_row.push(current_title);
        let empty_text = {
          text: '',
          alignment: 'center',
          style: 'tableLine'
        };
        sum_row.push(empty_text);
        let current_sum = {
          border: [false, true, false, false],
          text: sum,
          alignment: 'center',
          style: 'sumRow'
        };
        sum_row.push(current_sum);
        sum_row.push(empty_text);

        documentDefinition.content[1].columns[1].table.body.push(sum_row);

        delete documentDefinition.content[0].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Không có dữ liệu danh sách màu tồn", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel danh sách màu tồn
  async exportExcelListInventoryColor() {
    let result: any = await this.reportsService.getAllColorPaintExist(this.userId);

    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "BaoCaoDanhSachMauTon.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Báo cáo danh sách xuất hàng trong ngày
  async exportListReleaseToday() {
    let today = new Date();

    let result: any = await this.reportsService.getAllColorPaintFormulaTempAsync(today, today, null, null, null, this.userId);

    if (result.statusCode == 200) {
      let listData: Array<any> = result.colorPaintFormulaTempList;
      if (listData.length > 0) {
        let documentDefinition = {
          pageSize: 'A4',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'Danh Sách Xuất Hàng', style: 'header', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    body: [
                      [
                        { text: 'Tên khách hàng', style: 'tableHeader', alignment: 'center' },
                        { text: 'Ngày tháng', style: 'tableHeader', alignment: 'center' },
                        { text: 'Mã sơn', style: 'tableHeader', alignment: 'center' },
                        { text: 'Mã màu', style: 'tableHeader', alignment: 'center' },
                        { text: 'Khối lượng(kg)', style: 'tableHeader', alignment: 'center' },
                        { text: 'Công thức', style: 'tableHeader', alignment: 'center' },
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: false,
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; }
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            }
          }
        };

        listData.forEach(item => {
          let option = [];
          let current_customer_name = {
            text: item.customerName,
            alignment: 'center',
            style: 'tableLine'
          };
          option.push(current_customer_name);
          let current_created_date = {
            text: this.formatDate(item.createdDate),
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_created_date);
          let current_product_code = {
            text: item.productCode,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_product_code);
          let current_color_code = {
            text: item.colorCode,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_color_code);
          let current_mass_book = {
            text: item.massBook,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_mass_book);
          let current_formula = {
            text: item.formula,
            alignment: 'center',
            style: 'tableLine'
          }
          option.push(current_formula);

          documentDefinition.content[1].columns[1].table.body.push(option);
        });

        delete documentDefinition.content[0].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Chưa có dữ liệu", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel BC danh sách xuất hàng trong ngày
  async exportExcelListReleaseToday() {
    let today = new Date();

    let result: any = await this.reportsService.exportExcelAllColorPaintFormulaTempAsync(today, today, null, null, null, this.userId);

    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "DSXuatHangTrongNgay.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  goToReportProduct() {
    this.router.navigate(['reports/product']);
  }
  goToReportColor() {
    this.router.navigate(['reports/color']);
  }
  goToReportColorDeep() {
    this.router.navigate(['reports/color-deep']);
  }
  goToReportBriefly() {
    this.router.navigate(['reports/briefly']);
  }
  goToReportOutStock() {
    this.router.navigate(['reports/out-stock']);
  }

  //Báo cáo nhập sơn
  async exportReportIncludeProduct() {
    let startDate = new Date();
    startDate.setDate(1);
    let endDate = new Date();

    let result: any = await this.reportsService.getReportIncludeProduct(startDate, endDate, this.userId);
    if (result.statusCode) {
      if (result.reportImportPaintList.length > 0) {
        let listData: Array<any> = result.reportImportPaintList;

        let documentDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'BÁO CÁO NHẬP SƠN TRONG THÁNG', style: 'header', alignment: 'center', columns: [] },
            { text: 'Từ ngày ' + this.formatDate(startDate) + ' đến ngày ' + this.formatDate(endDate), style: 'subTitle', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    dontBreakRows: true,
                    body: [
                      [
                        { border: [false, false, false, true], text: 'Tên sơn', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Ngày tháng', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Khối lượng nhập', style: 'tableHeader', alignment: 'center' }
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: true,
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                    hLineStyle: function (i, node) {
                      let tableBody: Array<any> = node.table.body;
                      let list: Array<number> = [];
                      tableBody.forEach((item: Array<any>, index) => {
                        if (index != 0) {
                          if (item[0].text != "") {
                            if (list.indexOf(index) == -1) {
                              list.push(index);
                            }
                          }
                        }
                      });

                      if (i === 0 || i === 1 || i === (node.table.body.length - 1) || (list.indexOf(i) != -1)) {
                        return null;
                      }

                      return { dash: { length: 2 } };
                    },
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            subTitle: {
              fontSize: 10,
              italics: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            },
            sum: {
              fontSize: 10,
              bold: true
            }
          }
        };

        listData.forEach(item => {

          let row = [
            { border: [false, true, false, true], text: item.productCode, style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: item.totalMass, style: 'tableHeader', alignment: 'center' },
          ];

          documentDefinition.content[2].columns[1].table.body.push(row);

          let subListData: Array<any> = item.importPaintList;
          subListData.forEach(subItem => {
            let subRow = [
              { border: [false, false, false, false], text: '', style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: this.formatDate(subItem.createdDate), style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: subItem.mass, style: 'tableLine', alignment: 'center' }
            ];

            documentDefinition.content[2].columns[1].table.body.push(subRow);
          });
        });

        delete documentDefinition.content[0].columns;
        delete documentDefinition.content[1].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Chưa có dữ liệu", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel báo cáo nhập sơn
  async exportExcelReportIncludeProduct() {
    let startDate = new Date();
    startDate.setDate(1);
    let endDate = new Date();

    let result: any = await this.reportsService.getReportIncludeProduct(startDate, endDate, this.userId);
    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "BaoCaoNhapSon.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  async exportReportIncludeColor() {
    let startDate = new Date();
    startDate.setDate(1);
    let endDate = new Date();

    let result: any = await this.reportsService.getReportIncludeColor(startDate, endDate, this.userId);
    if (result.statusCode == 200) {

      if (result.reportImportColorList.length > 0) {
        let listData: Array<any> = result.reportImportColorList;

        let documentDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'BÁO CÁO NHẬP MÀU TRONG THÁNG', style: 'header', alignment: 'center', columns: [] },
            { text: 'Từ ngày ' + this.formatDate(startDate) + ' đến ngày ' + this.formatDate(endDate), style: 'subTitle', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    dontBreakRows: true,
                    body: [
                      [
                        { border: [false, false, false, true], text: 'Loại mã màu', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Ngày tháng', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Mã loại hộp', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Số lượng vạch (vạch/hộp)', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Số lượng hộp (hộp)', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Tổng vạch nhập (vạch)', style: 'tableHeader', alignment: 'center' }
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: true,
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                    hLineStyle: function (i, node) {
                      let tableBody: Array<any> = node.table.body;
                      let list: Array<number> = [];
                      tableBody.forEach((item: Array<any>, index) => {
                        if (index != 0) {
                          if (item[0].text != "") {
                            if (list.indexOf(index) == -1) {
                              list.push(index);
                            }
                          }
                        }
                      });

                      if (i === 0 || i === 1 || i === (node.table.body.length - 1) || (list.indexOf(i) != -1)) {
                        return null;
                      }

                      return { dash: { length: 2 } };
                    },
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            subTitle: {
              fontSize: 10,
              italics: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            },
            sum: {
              fontSize: 10,
              bold: true
            }
          }
        };

        listData.forEach(item => {

          let row = [
            { border: [false, true, false, true], text: item.colorTypeCode, style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' },
            { border: [false, true, false, true], text: '', style: 'tableHeader', alignment: 'center' }
          ];

          documentDefinition.content[2].columns[1].table.body.push(row);

          let subListData: Array<any> = item.importColorList;
          subListData.forEach(subItem => {
            let subRow = [
              { border: [false, false, false, false], text: '', style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: this.formatDate(subItem.createdDate), style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: subItem.colorBoxCode, style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: subItem.totalBar, style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: subItem.numberBox, style: 'tableLine', alignment: 'center' },
              { border: [false, false, false, false], text: subItem.totalBarImport, style: 'tableLine', alignment: 'center' }
            ];

            documentDefinition.content[2].columns[1].table.body.push(subRow);
          });
        });

        delete documentDefinition.content[0].columns;
        delete documentDefinition.content[1].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Chưa có dữ liệu", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel báo cáo nhập màu
  async exportExcelReportIncludeColor() {
    let startDate = new Date();
    startDate.setDate(1);
    let endDate = new Date();

    let result: any = await this.reportsService.getReportIncludeColor(startDate, endDate, this.userId);
    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "BaoCaoNhapMau.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Báo cáo tồn kho sơn
  async exportReportProductRest() {
    let result: any = await this.reportsService.getReportProductRest(this.userId);
    if (result.statusCode == 200) {
      if (result.paintStoreList.length > 0) {
        let listData: Array<any> = result.paintStoreList;

        let documentDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'LƯỢNG SƠN TỒN TRONG KHO', style: 'header', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    dontBreakRows: true,
                    body: [
                      [
                        { border: [false, false, false, true], text: 'Tên sơn', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Khối lượng tồn (kg)', style: 'tableHeader', alignment: 'center' },
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: true,
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            subTitle: {
              fontSize: 10,
              italics: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            },
            sum: {
              fontSize: 10,
              bold: true
            }
          }
        };

        listData.forEach(item => {

          let row = [
            { border: [false, false, false, false], text: item.productCode, style: 'tableLine', alignment: 'center' },
            { border: [false, false, false, false], text: item.numberExist, style: 'tableLine', alignment: 'center' },
          ];

          documentDefinition.content[1].columns[1].table.body.push(row);
        });

        delete documentDefinition.content[0].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Chưa có dữ liệu", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel báo cáo tồn kho sơn
  async exportExcelReportProductRest() {
    let result: any = await this.reportsService.getReportProductRest(this.userId);
    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "BaoCaoTonKhoSon.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Báo cáo tồn kho màu
  async exportReportColorRest() {
    let result: any = await this.reportsService.getReportColorRest(this.userId);
    if (result.statusCode == 200) {
      if (result.colorStoreList.length > 0) {
        let listData: Array<any> = result.colorStoreList;

        let documentDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [20, 20, 20, 20],
          content: [
            { text: 'LƯỢNG MÀU CÒN LẠI', style: 'header', alignment: 'center', columns: [] },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  style: 'table',
                  table: {
                    dontBreakRows: true,
                    body: [
                      [
                        { border: [false, false, false, true], text: 'Mã loại màu', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Tên loại màu', style: 'tableHeader', alignment: 'center' },
                        { border: [false, false, false, true], text: 'Số lượng tồn (vạch)', style: 'tableHeader', alignment: 'center' }
                      ],
                    ]
                  },
                  layout: {
                    defaultBorder: true,
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                  }
                },
                { width: '*', text: '' },
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 18.5,
              bold: true
            },
            subTitle: {
              fontSize: 10,
              italics: true
            },
            table: {
              margin: [0, 15, 0, 15]
            },
            tableHeader: {
              fontSize: 12,
              bold: true
            },
            tableLine: {
              fontSize: 10,
            },
            sum: {
              fontSize: 10,
              bold: true
            }
          }
        };

        listData.forEach(item => {

          let row = [
            { border: [false, false, false, false], text: item.colorCode, style: 'tableLine', alignment: 'center' },
            { border: [false, false, false, false], text: item.colorName, style: 'tableLine', alignment: 'center' },
            { border: [false, false, false, false], text: item.numberExist, style: 'tableLine', alignment: 'center' }
          ];

          documentDefinition.content[1].columns[1].table.body.push(row);
        });

        delete documentDefinition.content[0].columns;

        pdfMake.createPdf(documentDefinition).open();
      } else {
        this.snackBar.openFromComponent(WarningComponent, { data: "Chưa có dữ liệu", ... this.warningConfig });
      }
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  //Xuất excel báo cáo tồn kho màu
  async exportExcelReportColorRest() {
    let result: any = await this.reportsService.getReportColorRest(this.userId);
    if (result.statusCode == 200) {
      const binaryString = window.atob(result.exportToExcel);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let idx = 0; idx < binaryLen; idx++) {
        const ascii = binaryString.charCodeAt(idx);
        bytes[idx] = ascii;
      }
      const blob = new Blob([bytes], { type: 'xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = "BaoCaoTonKhoMau.xlsx";
      link.download = fileName;
      link.click();
    } else {
      this.snackBar.openFromComponent(FailComponent, { data: "Lấy dữ liệu thất bại", ... this.failConfig });
    }
  }

  /*End: Báo cáo*/

  /*Thêm class active trên menu*/

  //Quản lý sản phẩm
  checkRouterProduct() {
    let url = this.router.url;
    if (url.indexOf('/product/') != -1) {
      return 'active';
    }
  }

  checkRouterOrder() {
    let url = this.router.url;
    if (url.indexOf('/order/') != -1) {
      return 'active';
    }
  }

  //Báo cáo
  checkRouterReports() {
    let url = this.router.url;
    if (url.indexOf('/reports/') != -1) {
      return 'active';
    }
  }

  checkRouterReportsChild(mudule_child) {
    let url = this.router.url;

    if (url === mudule_child) {
      return 'active';
    } else {
      return '';
    }
  }

  //Quản lý công thức
  checkRouterFormula() {
    let url = this.router.url;
    if (url.indexOf('/formula/') != -1) {
      return 'active';
    }
  }

  checkRouterFormulaChild(mudule_child) {
    let url = this.router.url;

    if (url === mudule_child) {
      return 'active';
    } else {
      return '';
    }
  }

  /*End*/

  /*Format date: dd/mm/yyyy*/
  formatDate(param) {
    let day = new Date(param);
    let dd = day.getDate();
    let mm = day.getMonth() + 1; //January is 0!
    let ngay: string;
    let thang: string;
    let result;

    var yyyy = day.getFullYear();
    if (dd < 10) {
      ngay = '0' + dd.toString();
    } else {
      ngay = dd.toString();
    }
    if (mm < 10) {
      thang = '0' + mm.toString();
    } else {
      thang = mm.toString();
    }
    return result = ngay + '/' + thang + '/' + yyyy.toString();
  }
  /*End*/
}



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu.component.ts